var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#E5F9ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1413 28.6086L26.1416 18.6084L21.3916 13.8584L11.3914 23.8587C11.2537 23.9965 11.1559 24.1691 11.1084 24.358L10 30L15.6409 28.8916C15.8303 28.8443 16.0036 28.7463 16.1413 28.6086V28.6086ZM29.3699 15.3801C29.7733 14.9765 30 14.4291 30 13.8584C30 13.2878 29.7733 12.7404 29.3699 12.3368L27.6632 10.6301C27.2596 10.2267 26.7122 10 26.1416 10C25.5709 10 25.0235 10.2267 24.6199 10.6301L22.9132 12.3368L27.6632 17.0868L29.3699 15.3801Z",
    fill: "#6AC982"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditButton);
export default __webpack_public_path__ + "static/media/edit-button.15ffee1848453f9bb848fe9477fbb5fe.svg";
export { ForwardRef as ReactComponent };